import { render, staticRenderFns } from "./DocumentModalPreview.vue?vue&type=template&id=824855ba&"
import script from "./DocumentModalPreview.vue?vue&type=script&lang=js&"
export * from "./DocumentModalPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports